<template>
  <div>
    <div v-for="accordion in accordions" :key="accordion.title">
      <BaseAccordian>
        <template v-slot:title>{{ accordion.title }}</template>

        <template v-slot:content>
          <div>{{ accordion.text }}</div>
        </template>
      </BaseAccordian>
    </div>
  </div>
</template>
<script>
import BaseAccordian from "@/components/BaseAccordion";

export default {
    name: 'Accordion',
  components: {
    BaseAccordian
  },
  data() {
    return {
      accordions: [
        {
          title: "How do I register my restaurant?",
          text: "To register your restaurant, you need to download our mobile app, put in the details of your restaurant when registering, accept the terms and conditions and you are done"
        },
        {
          title: "How do I know that my restaurant is visible to customers?",
          text: "Once you have completely registered and accepted the terms and conditions on our mobile app, your restaurant becomes visible on our app"
        },
        {
          title: "How do I get paid?",
          text: "Payment is done daily, we pay your sales for the day at around 8pm daily"
        },
        {
          title: "Do I need to pay any subscription fee?",
          text: "Since we are still in the Beta stage, the first one year is free to test out our application"
        },
        {
          title: "Who pays for the delivery fee?",
          text: "The customers handle the delivery fee"
        },
        {
          title: "Will my food sell at the normal price?",
          text: "The price in which you food sell depends on you as the restaurant, we only add 50 naira to it as our commission"
        }
      ]
    };
  }
};
</script>

<style  scoped>
</style>